import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
  showLabels?: boolean;
}
export function CountdownTimer({
  initialHours = 1,
  initialMinutes = 58,
  initialSeconds = 22,
  className = '',
  showLabels = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  if (showLabels) {
    return <div className={`flex items-center justify-center gap-2 font-bold ${className}`} data-id="element-78">
        <div className="flex flex-col items-center" data-id="element-79">
          <span className="text-3xl md:text-5xl" data-id="element-80">
            {formatTime(timeLeft.hours)}
          </span>
          <span className="text-xs md:text-sm uppercase" data-id="element-81">Horas</span>
        </div>
        <span className="text-3xl md:text-5xl pb-5" data-id="element-82">:</span>
        <div className="flex flex-col items-center" data-id="element-83">
          <span className="text-3xl md:text-5xl" data-id="element-84">
            {formatTime(timeLeft.minutes)}
          </span>
          <span className="text-xs md:text-sm uppercase" data-id="element-85">Min</span>
        </div>
        <span className="text-3xl md:text-5xl pb-5" data-id="element-86">:</span>
        <div className="flex flex-col items-center" data-id="element-87">
          <span className="text-3xl md:text-5xl" data-id="element-88">
            {formatTime(timeLeft.seconds)}
          </span>
          <span className="text-xs md:text-sm uppercase" data-id="element-89">Seg</span>
        </div>
      </div>;
  }
  return <span className={className} data-id="element-90">
      {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
      {formatTime(timeLeft.seconds)}
    </span>;
}